var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.234375,
    y: 0.140625,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_58326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8261 41.2537C32.5417 41.2537 40.4178 33.3776 40.4178 23.662C40.4178 13.9464 32.5417 6.07031 22.8261 6.07031C13.1104 6.07031 5.23438 13.9464 5.23438 23.662C5.23438 33.3776 13.1104 41.2537 22.8261 41.2537Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2712 12.7979C26.2712 12.3524 25.7326 12.1293 25.4177 12.4443L13.9475 23.9146C13.827 24.0352 13.745 24.1887 13.7118 24.3559C13.6786 24.523 13.6957 24.6963 13.7609 24.8537C13.8261 25.0112 13.9365 25.1458 14.0781 25.2405C14.2198 25.3353 14.3863 25.3859 14.5568 25.3861H18.8851C19.1612 25.3861 19.3851 25.61 19.3851 25.8861V34.5255C19.3851 34.9709 19.9236 35.194 20.2386 34.879L31.709 23.4088C31.8293 23.2882 31.9114 23.1346 31.9445 22.9675C31.9777 22.8003 31.9607 22.6271 31.8955 22.4696C31.8302 22.3122 31.7199 22.1776 31.5783 22.0828C31.4366 21.9881 31.2701 21.9374 31.0996 21.9373H26.7712C26.4951 21.9373 26.2712 21.7134 26.2712 21.4373V12.7979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_58326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37,
    fill: "white",
    transform: "translate(5.23438 5.14062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv6);
export default __webpack_public_path__ + "static/media/div6.fbd7733d7db95101ffeb276b723e338e.svg";
export { ForwardRef as ReactComponent };